"use client";

import { c as _c } from "react/compiler-runtime";
import type { FC } from "react";
import { useMemo, useRef } from "react";
import type { ApiWave } from "@/generated/models/ApiWave";
import { WaveOutcome } from "@/components/waves/outcome/WaveOutcome";
import { useLayout } from "./layout/LayoutContext";
import SpinnerLoader from "@/components/common/SpinnerLoader";
import { useInfiniteScroll } from "@/hooks/useInfiniteScroll";
import { useWaveOutcomesQuery } from "@/hooks/waves/useWaveOutcomesQuery";
interface MyStreamWaveOutcomeProps {
  readonly wave: ApiWave;
}
const MyStreamWaveOutcome: FC<MyStreamWaveOutcomeProps> = t0 => {
  const $ = _c(23);
  const {
    wave
  } = t0;
  const {
    outcomeViewStyle
  } = useLayout();
  const scrollContainerRef = useRef(null);
  const sentinelRef = useRef(null);
  let t1;
  if ($[0] !== wave.id) {
    t1 = {
      waveId: wave.id
    };
    $[0] = wave.id;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    outcomes,
    fetchNextPage,
    hasNextPage,
    isFetching,
    isFetchingNextPage,
    isLoading,
    errorMessage
  } = useWaveOutcomesQuery(t1);
  useInfiniteScroll(hasNextPage, isFetchingNextPage, fetchNextPage, scrollContainerRef, sentinelRef, "200px");
  const hasOutcomes = outcomes.length > 0;
  const isInitialLoading = isLoading && !hasOutcomes;
  let t2;
  if ($[2] !== isInitialLoading) {
    t2 = isInitialLoading && <SpinnerLoader text="Loading outcomes..." />;
    $[2] = isInitialLoading;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== errorMessage || $[5] !== isInitialLoading) {
    t3 = !isInitialLoading && errorMessage && <div className="tw-px-4 tw-text-sm tw-text-red-400">{errorMessage}</div>;
    $[4] = errorMessage;
    $[5] = isInitialLoading;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== errorMessage || $[8] !== hasOutcomes || $[9] !== isFetching || $[10] !== isInitialLoading) {
    t4 = !isInitialLoading && !errorMessage && !hasOutcomes && !isFetching && <div className="tw-px-4 tw-text-sm tw-text-iron-500">No outcomes to show.</div>;
    $[7] = errorMessage;
    $[8] = hasOutcomes;
    $[9] = isFetching;
    $[10] = isInitialLoading;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== hasOutcomes || $[13] !== isFetchingNextPage || $[14] !== outcomes || $[15] !== wave.id) {
    t5 = hasOutcomes && <div className="tw-px-2 sm:tw-px-4 tw-space-y-4">{outcomes.map((outcome, index) => <WaveOutcome waveId={wave.id} key={`${outcome.index ?? index}-${outcome.type}`} outcome={outcome} />)}<div ref={sentinelRef} style={{
        height: "1px"
      }} />{isFetchingNextPage && <SpinnerLoader text="Loading more outcomes..." />}</div>;
    $[12] = hasOutcomes;
    $[13] = isFetchingNextPage;
    $[14] = outcomes;
    $[15] = wave.id;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== outcomeViewStyle || $[18] !== t2 || $[19] !== t3 || $[20] !== t4 || $[21] !== t5) {
    t6 = <div className="tw-pt-4 tw-pb-4 tw-w-full tw-flex tw-flex-col tw-overflow-y-auto no-scrollbar lg:tw-scrollbar-thin tw-scrollbar-thumb-iron-500 tw-scrollbar-track-iron-800 desktop-hover:hover:tw-scrollbar-thumb-iron-300 tw-flex-grow lg:tw-pr-2" style={outcomeViewStyle} ref={scrollContainerRef}>{t2}{t3}{t4}{t5}</div>;
    $[17] = outcomeViewStyle;
    $[18] = t2;
    $[19] = t3;
    $[20] = t4;
    $[21] = t5;
    $[22] = t6;
  } else {
    t6 = $[22];
  }
  return t6;
};
export default MyStreamWaveOutcome;